import { Button, Divider, Radio, Space, Spin, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { apiCall, apiDownload } from "../../utils/Api";
import conditional from "../../utils/conditional";
import ListReportCardDetailedView from "./ListReportCardDetailedView";
import ListReportCardSimplifiedView from "./ListReportCardSimplifiedView";

export default function ListReportCard(props) {
    const { 
        close = () => { }, 
        actual_id = "",
        list_id = "",
        list_name = "",
        vendor
    } = props;

    const [reportCardData, setReportCardData] = useState({});
    const [detailedReportCardData, setDetailedReportCardData] = useState({});
    const [displayValue, setDisplayValue] = useState("simple");
    const [initLoaded, setInitLoaded] = useState(false);

    const actual_id_array = Array.isArray(actual_id) ? actual_id : [actual_id];
    const list_id_array = Array.isArray(list_id) ? list_id : [list_id];

    const getStartingValues = () => {
        apiCall("titlelist/missing_data/get", {titlelist_def_id: JSON.stringify(actual_id_array)}, (_status, _result) => {
            if(_status){
                setReportCardData(_result)
                parseReportCardData(_result)
            }
        })
    }
    
    useEffect(getStartingValues, [])

    function parseReportCardData(api_results){
        let temp_data = [];
        let isbns_array = [];
        Object.values(api_results.missing_isbns).map((data_array_values) => {
            Object.keys(data_array_values).forEach((isbn) => {
                if(!isbns_array.includes(isbn)){
                    isbns_array.push(isbn);
                }
            })
        })
        isbns_array.forEach((isbn) => {
            let temp_object = {
                isbn: isbn,
                author_bios: false,
                covers: false,
                description: false,
                interiors: false,
                marketing: false,
                pubstock: false,
                related: false,
                reviews: false,
                titles: false
            }
            Object.entries(api_results.missing_isbns).forEach((data_array_values) => {
                Object.keys(data_array_values[1]).forEach((individual_value) => {
                    if(individual_value === isbn){
                        temp_object[data_array_values[0]] = true;
                    }
                })
                
            })
            temp_data.push(temp_object)
        })
        setDetailedReportCardData(temp_data);
        setInitLoaded(true);
    }

    function openBrowse(){

        if(!Array.isArray(actual_id)){
            window.open("/browse/filter/x/" + actual_id + "/v/sequence", "_blank");
        } else {
            apiCall("titlelist/missing_data/getCacheKeyForTitleList", {titlelist_def_id: JSON.stringify(actual_id_array)}, (_status, _result) => {
                if(_status){
                    window.open("/browse/filter/x/" + _result.id + "/v/sequence", "_blank");
                }
            })
        }
    }
    
    const getExcelForReportCard = () => {
        apiDownload({"titlelist_def_id": JSON.stringify(list_id_array)}, "titlelist/missing_data/getExcel")
    }

    return (
        <>
        
            {(!initLoaded && <div style={{ "padding": "20px" }}>
                <Typography.Title level={5}><big>Head's up! Larger catalogues (anything over 1K isbns) can take a bit more time to load.</big></Typography.Title>
                <Spin spinning={!initLoaded}>
                    <div style={{ "width": "1310px", "margin": "0 auto", "height": "500px" }}></div>
                </Spin>
            </div>)}
            {(initLoaded && <div style={{ "padding": "20px" }}>
                <Typography.Title level={5}>
                    <big>
                        Report Card for: {
                            Array.isArray(list_name)
                                ? list_name.length > 1
                                    ? <>{list_name.length} catalogues</>
                                    : list_name[0]
                                : list_name
                        }
                    </big>
                </Typography.Title>                    
                <Divider style={{"margin" : "15px 0px"}} dashed />
                <span>
                    <Tooltip>
                        <Radio.Group defaultValue={"simple"} buttonStyle="solid" onChange={(e) => setDisplayValue(e.target.value)}>
                            <Radio.Button value="simple">Simplified View</Radio.Button>
                            <Radio.Button value="detail">Detailed View</Radio.Button>
                        </Radio.Group>
                    </Tooltip>
                </span>
                <div className="shim"/>
                <conditional.true value={displayValue === "simple"}>
                    <ListReportCardSimplifiedView
                        vendor={vendor}
                        reportCardData={reportCardData}
                        />
                </conditional.true>
                <conditional.true value={displayValue === "detail"}>
                    <ListReportCardDetailedView
                        vendor={vendor}
                        reportCardData={detailedReportCardData}
                        />
                </conditional.true>
                <div className="shim"/>
                <span>
                    <div style={{ "float": "left" }}>
                        <Button type="danger" onClick={() => close()}>Cancel</Button>
                    </div>
                    <div style={{"float": "right"}}>
                        <Space>
                            <Button onClick={() => getExcelForReportCard()}>Get Report Card Excel</Button>
                            <Button onClick={() => openBrowse()} type="primary">Open in Browse</Button>
                        </Space>
                    </div>
                </span>
                <br clear="all" />
            </div>)}
        </>
    )
}